import { useNudges } from '@/hooks';
import { Flex, Icon, Text, useDisclosure } from '@chakra-ui/react';
import React, { Fragment } from 'react';
import { ShowMoreNudges, InlineNudges } from './components';
import { ChevronDown } from '@kula-ai/icons-core';
import { useNudgesConfig } from './useNudgesConfig';

export const Nudges = () => {
  const { activeNudges } = useNudges();
  const showNudges = activeNudges?.length > 0;
  const [firstItem, ...remainingNudges] = activeNudges;
  const showRemaining = remainingNudges?.length > 0;
  const { isOpen, onOpen, onClose: disclosureOnclose } = useDisclosure();
  const nudgesConfig = useNudgesConfig();

  const remainingNudgesToRender = remainingNudges.map(
    (item) => nudgesConfig[item.id]
  );

  if (!showNudges) return null;

  const { bgColor = 'ats-primary', variant } =
    nudgesConfig[firstItem?.id] || {};

  const renderRemainingNudges = () => {
    return (
      <Flex
        p="2px 8px"
        bgColor={variant === 'secondary' ? 'ats-primary' : 'white'}
        borderRadius="52px"
        alignItems="center"
        gap="4px"
        cursor="pointer"
        onClick={onOpen}
      >
        <Text
          size="sm-medium"
          color={variant === 'secondary' ? 'white' : 'ats-primary'}
        >
          +{remainingNudges?.length} message{remainingNudges?.length > 1 && 's'}
        </Text>
        <Icon
          color={variant === 'secondary' ? 'white' : 'ats-primary'}
          as={ChevronDown}
        />
      </Flex>
    );
  };

  return (
    <>
      <Flex
        maxH="32px"
        minH="32px"
        w="100%"
        bgColor={bgColor}
        justifyContent="center"
        alignItems="center"
        gap="10px"
      >
        <InlineNudges config={nudgesConfig[firstItem?.id]} />
        {showRemaining && renderRemainingNudges()}
        {isOpen && (
          <ShowMoreNudges
            nudges={remainingNudgesToRender}
            disclosureOnclose={disclosureOnclose}
          />
        )}
      </Flex>
    </>
  );
};
